import type { FlatRoute } from '../nav/manifest.ts'
import { unbuiltCopy, unbuiltEyebrow } from '../nav/manifest.ts'
import { EmptyState } from '../components/ui/EmptyState'

/**
 * The one screen behind every `dayN` route.
 *
 * CONSOLES.md 5 is the object model pattern applied to navigation: one descriptor per route,
 * and the surface generated from it. There is no per-route placeholder component and there
 * must not be, because thirty hand-written "coming soon" screens are thirty files to delete
 * later and thirty chances for one of them to say nothing useful. The copy is derived by
 * `unbuiltCopy` and `unbuiltEyebrow`, the same way the Admin Console derives its own.
 *
 * A route becomes real by a screen module appearing under `src/screens/` and its `status`
 * changing to `live`. Not by editing this file.
 */
export function PendingScreen({ route }: { route: FlatRoute }) {
  return (
    <>
      <div className="page-head">
        <div>
          <div className="eb">{route.section}</div>
          <h1>{route.title}</h1>
          <div className="sub">{route.spec}</div>
        </div>
      </div>

      <EmptyState icon={route.icon} eyebrow={unbuiltEyebrow(route)} title={unbuiltCopy(route)} />
    </>
  )
}
